import { Icon } from "@iconify/react"
import { Button, Card, Flex, Grid, Input, message, Pagination, Table, Tag } from "antd"
import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { keepPreviousData, useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import useTitleStore from "../../../store/titleStore";
import { useTableHeight } from "../../../hooks/useTableHeight";
import useDebounce from "../../../hooks/useDebounce";
import TableAction from "../../../components/TableAction";
import { ratePerCommodityService } from "../../../services/rate-per-commodity.service";
import UpdatedByCell from "../../../components/UpdatedByCell";

export default function RatePerCommodityIndex(){

  const breakpoint = Grid.useBreakpoint()

  const navigate = useNavigate();
  const { setTitle } = useTitleStore();
  const queryClient = useQueryClient();
  const tableHeight = useTableHeight();
  
  const [messageApi, contextHolder] = message.useMessage();
  const [keyword, setKeyword] = useState("");
  const debouncedKeyword = useDebounce(keyword, 500);
  const [dataParams, setDataParams] = useState({
    limit: 10,
    page: 1,
    filter: []
  })

  const { data: informationData , isLoading, isRefetching } = useQuery({
    queryKey: ['faqs', dataParams],
    queryFn: () => ratePerCommodityService.fetchAll(dataParams),
    placeholderData: keepPreviousData,
  })

  const { mutate: handleDelete, isPending: deleteLoading } = useMutation({
    mutationFn: (id) => ratePerCommodityService.delete(id),
    onSuccess: () => {
      queryClient.invalidateQueries('faqs');
      messageApi.success('Data berhasil dihapus');
    },
    onError: (error) => {
      console.log(error)
    }
  })

  useEffect(() => {
    setTitle("Layanan Lab - Tarif Per Komoditas");
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setDataParams((prev) => ({
      ...prev,
      filter: [
        {
          field: 'name',
          operator: 'like',
          value: debouncedKeyword
        }
      ]
    }));
  }, [debouncedKeyword]);

  const handleChangePage = (page, pageSize) => {
    setDataParams({
      ...dataParams,
      limit: pageSize,
      page
    })
  }

  const columns = [
    {
      title: 'No',
      align: 'center',
      width: 80,
      render: (text, record, index) =>  index + 1,
      fixed: breakpoint.md && 'left'
    },
    {
      title: 'Layanan',
      dataIndex: 'name',
      width: 210,
      fixed: breakpoint.md && 'left'
    },
    {
      title: 'Parameter',
      dataIndex: 'parameter',
      width: 120,
      render: val => <Tag color="blue" >{val?.length || 0}</Tag>,
      align: 'center'
    },
    {
      title: 'Komersil',
      dataIndex: 'komersil_total',
      width: 130,
      align: 'center',
      render: val => new Intl.NumberFormat("id-ID", {
        style: "currency",
        currency: "IDR",
        maximumFractionDigits: 0,
      }).format(val)
    },
    {
      title: 'Non Komersil',
      dataIndex: 'non_komersil_total',
      width: 130,
      align: 'center',
      render: val => new Intl.NumberFormat("id-ID", {
        style: "currency",
        currency: "IDR",
        maximumFractionDigits: 0,
      }).format(val)
    },
    {
      title: 'Express',
      dataIndex: 'express_total',
      width: 130,
      align: 'center',
      render: val => new Intl.NumberFormat("id-ID", {
        style: "currency",
        currency: "IDR",
        maximumFractionDigits: 0,
      }).format(val)
    },
    {
      title: 'Updated By',
      width: 210,
      render: val => <UpdatedByCell value={val} />,
    },
    {
      className: 'last-cell-p',
      title: 'Aksi',
      align: 'right',
      width: 120,
      fixed: 'right',
      render: record => (
        <TableAction
          onClickEdit={() => navigate('/lab-service/rate-per-commodity/detail/'+record.id)}
          handleDelete={() => handleDelete(record.id)}
          deleteLoading={deleteLoading}
        />
      )
    },
  ]



  return (
    <Card
      styles={{
        body: {
          paddingLeft: 0,
          paddingRight: 0
        }
      }}
    >
      {contextHolder}
      <Flex justify="space-between" style={{ paddingInline: 24, marginBottom: 24 }} gap={20} >
        <Input 
          style={{ width: 320 }} 
          prefix={<Icon icon="hugeicons:search-01" width="16" height="16" />}
          placeholder="cari..."
          onChange={e => setKeyword(e.target.value)}
          value={keyword}
        />
        <Button 
          variant="solid" 
          color="primary"  
          icon={<Icon icon="duo-icons:add-circle" width="22" height="22" />}
          onClick={() => navigate('/lab-service/rate-per-commodity/create')}
          style={{ minWidth: 38 }}
        >
          { breakpoint.md && 'Tambah Data'}
        </Button>
      </Flex>
      <Table
        columns={columns}
        pagination={false}
        size="small"
        loading={isLoading || isRefetching}
        rowKey={'id'}
        scroll={{ y: tableHeight }}
        dataSource={informationData?.data}
      />
       <Pagination
          style={{ marginInline: 24, marginTop: 16 }}
          total={informationData?.pagination?.total}
          showSizeChanger={{
            showSearch: false,
          }}
          pageSizeOptions={['10', '20', '50']}
          current={informationData?.pagination?.page}
          pageSize={dataParams.limit}
          align="end"
          onChange={handleChangePage}
        />
    </Card>
  )
}